export const getActiveStateProperty = name => `isActive${name}`



// WEBPACK FOOTER //
// ./src/app/getActiveStateProperty.js